import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CoreUtilService } from '../../../utils/core-util.service';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { AddEmailAddressAdapterService } from '../../adapters/add-email-address/add-email-address-adapters.service';
import { VIEW_NAME } from '../../constants/login-constant';
import { LoginContentService, NextDisplayViewService } from '../../services';
import { AddEmailAddressApiService } from '../../services/add-email-address/add-email-address-api.service';
import { AddEmailAddressHelperService } from '../../services/add-email-address/add-email-address-helper.service';
import { AddSqaFacadeService } from '../add-sqa/add-sqa-facade.service';
import { FacadeService } from '../facade.service';

@Injectable({
  providedIn: 'root'
})
export class AddEmailAddressBaseFacadeService {
  viewName = VIEW_NAME;
  aemContentService = inject(LoginContentService);
  addEmailAddressAdapter = inject(AddEmailAddressAdapterService);
  helperService = inject(AddEmailAddressHelperService);
  apiService = inject(AddEmailAddressApiService);
  loginHelperUtils = inject(LoginHelperUtils);
  nextDisplayViewService = inject(NextDisplayViewService);
  loginAuthFacade = inject(FacadeService);
  addSqaFacadeService = inject(AddSqaFacadeService);
  router = inject(Router);
  coreUtilService = inject(CoreUtilService);
}
